import React from 'react';
import { Icon } from '@noths/polaris-design-system-core-components';

import type { FavouriteButtonProps } from './FavouriteButton.types';
import { SIZES } from './FavouriteButton.styles';
import * as styles from './FavouriteButton.styles';

export const FavouriteButton = ({
  active = false,
  activeIcon = 'favoriteFull',
  className,
  inactiveIcon = 'favoriteEmpty',
  label = 'Favourite',
  onClick,
  size = 'lg',
}: FavouriteButtonProps) => {
  const iconSize = SIZES[size].icon;

  return (
    <button
      aria-label={label}
      aria-pressed={active}
      className={className}
      css={styles.root(size)}
      onClick={onClick}
      type="button"
    >
      <span css={styles.stack}>
        <span css={styles.heartInactive}>
          <Icon aria-hidden data-icon={inactiveIcon} name={inactiveIcon} size={iconSize} />
        </span>
        <span css={styles.heartFull}>
          <Icon aria-hidden data-icon={activeIcon} name={activeIcon} size={iconSize} />
        </span>
      </span>
    </button>
  );
};

FavouriteButton.displayName = 'FavouriteButton';
